import React from 'react'

function UserSettings() {
  return (
    <div>UserSettings</div>
  )
}

export default UserSettings